module.exports = __webpack_public_path__ + "static/media/2020.10.21文体助力沪剧赏析活动.70bcd807.jpg";